<template>
	<section class="view-venue-revisionsummary padded alternate-panel" v-if="venueModel.getRevisionSummary()">
		<h4>
			<img
				class="filter-invert push-bottom"
				height="48"
				src="~@chalkysticks/sass/build/asset/image/icon/chat.svg"
			/>
			<br />
			People are saying...
		</h4>

		<blockquote>
			<p>&ldquo;{{ venueModel.getRevisionSummary() }}&rdquo;</p>
		</blockquote>

		<small class="push-top">
			<em>* Summary of community contributions</em>
		</small>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays a summary of community revision contributions for a venue.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueRevisionSummary extends ViewBase {
		/**
		 * The venue model containing revision summary data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;
	}
</script>

<style lang="scss">
	.view-venue-revisionsummary {
		padding: 2rem 1rem;
		text-align: center;

		blockquote {
			border-color: transparent;
			margin: 0 1rem;
			padding-bottom: 0;
		}
	}
</style>
